import { render, staticRenderFns } from "./InvoiceCorrectionDialog.vue?vue&type=template&id=cf21e972&scoped=true"
import script from "./InvoiceCorrectionDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceCorrectionDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCorrectionDialog.vue?vue&type=style&index=0&id=cf21e972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf21e972",
  null
  
)

export default component.exports